import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refProductListTable = ref(null)

  // Table Handlers
  const tableColumns = [

    { key: 'sell_date', label: 'Satış Tarih', sortable: true },
    { key: 'buyer', label: 'Cari Adı', sortable: false },
    { key: 'seller_code', label: 'Satıcı Kodu', sortable: false },
    { key: 'seller_name', label: 'Satıcı Adı', sortable: false },
    { key: 'location', label: 'Ülke/Şehir', sortable: false },
    { key: 'category', label: 'Kategori', sortable: false },
    { key: 'other_category', label: 'ALt Kategori', sortable: false },
    { key: 'product_name', label: 'Ürün Adı', sortable: false },
    { key: 'stock_code', label: 'Stok Kodu', sortable: false },
    { key: 'currency', label: 'Döviz', sortable: false },
    { key: 'exchange_rate', label: 'Döviz Kuru', sortable: false },
    { key: 'piece', label: 'Miktar Adet', sortable: false },
    { key: 'currency_unit_price', label: 'Döviz BirimFiyat', sortable: false },
    { key: 'tl_unit_price', label: 'Tl Birim Fiyat', sortable: false },
    { key: 'currency_invoice_total', label: 'Döviz Fatura Toplam', sortable: false },
    { key: 'tl_invoice_total', label: 'Tl Fatura Toplam', sortable: false },
    { key: 'rebate', label: 'Rebate', sortable: false },
    { key: 'tl_net_unit', label: 'Tl Net Birim', sortable: false },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalProducts = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const d = new Date()
  const thisYear = d.getFullYear()
  const targetMonth = ref(null)

  const targetYear = ref(thisYear)
  const dataMeta = computed(() => {
    const localItemsCount = refProductListTable.value ? refProductListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalProducts.value,
    }
  })

  const refetchData = () => {
    refProductListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchProducts = (ctx, callback) => {
    store
      .dispatch('app-sales/fetchProducts', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
        targetYear: targetYear.value,
        targetMonth: targetMonth.value,
      })
      .then(response => {
        const products = response.data.data.products.data
        const { total } = response.data.meta

        callback(products)
        totalProducts.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching product list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    targetYear,
    targetMonth,
    fetchProducts,
    tableColumns,
    perPage,
    currentPage,
    totalProducts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refProductListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
